var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 231,
    viewBox: "0 0 99 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6264 118.949L53.3409 116.034V114.657L49.0174 115.357L44.6939 114.657V116.034L26.4084 118.949L5.69486 158.33C-11.452 190.914 12.1871 230.07 49.0174 230.07C85.8477 230.07 109.487 190.928 92.34 158.33L71.6264 118.949Z",
    fill: "#F4DAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0308 181.79C98.0308 181.685 98.0308 181.58 98.0308 181.475C98.0308 181.37 98.0308 181.275 98.0308 181.174C97.6594 155.807 77.2017 132.904 49.0183 132.904C20.835 132.904 0.380749 155.821 0.00585938 181.188C0.00585938 181.289 0.00585938 181.391 0.00585938 181.496C0.00585938 181.601 0.00585938 181.699 0.00585938 181.801C0.380749 207.167 20.835 230.084 49.0183 230.084C77.1982 230.07 97.6559 207.157 98.0308 181.79Z",
    fill: "#F9E4CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3395 158.33L71.6259 118.949L53.3404 116.034V114.657L49.0169 115.343L44.6934 114.657V116.034L26.4079 118.949L5.69434 158.33",
    stroke: "#EACAA4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0172,
    cy: 123.328,
    r: 8.67152,
    fill: "#F4B651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3457 123.328C40.3457 118.539 44.2281 114.657 49.0172 114.657C53.8064 114.657 57.6887 118.539 57.6887 123.328C57.6887 128.117 53.8064 132 49.0172 132",
    stroke: "#1E2454",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.016 0V100.204",
    stroke: "#1E2454",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7028 123.329C84.646 105.958 67.7669 94.5967 49.0179 94.5967C30.2689 94.5967 13.3898 105.958 6.33301 123.329H91.7028Z",
    fill: "#CE3669"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.016 94.5986V100.204",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7028 123.329C84.646 105.958 67.7669 94.5967 49.0179 94.5967C30.2689 94.5967 13.3898 105.958 6.33301 123.329",
    stroke: "#1E2454",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.db81f9bcb235181a5376c1d8685d9edd.svg";
export { ForwardRef as ReactComponent };